<cc-instagram-data *ngIf="displayInstagramStories" [gamingStoriesData]="gamingData" [config]="config" (dataNotExists)="dataNotExistsEmit($event)">
</cc-instagram-data>
